import { HttpClient } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { getCookie } from '../utils/get-cookie';
import { Observable } from 'rxjs';
import {
  IObjectivesFormState,
  IObjectivesRetirementFormState,
} from '../modules/objective/store/objective.state';
import { IJobFormState } from '../modules/collect-data/components/job-form/store/job-form.state';
import { IFamilyFormState } from '../modules/collect-data/components/family-form/store/family-form.state';
import { IIncomeTaxState } from '../modules/collect-data/components/income-tax/store/incomeTax.state';
import { IHealthInsuranceState } from '../modules/collect-data/components/health-insurance/store/healthInsurance.state';
import { IInsuranceState } from '../modules/collect-data/components/insurance/store/insurance.state';
import { IPensionState } from '../modules/collect-data/components/pension/store/pension.state';
import { IPropertiesState } from '../modules/collect-data/components/properties/store/properties.state';
import { IVehiclesState } from '../modules/collect-data/components/vehicles/store/vehicles.state';
import { IInssState } from '../modules/collect-data/components/inss-retirement/store/inss.state';
import { IInvestmentsState } from '../modules/collect-data/components/investments/store/investments.state';
import { IBudgetState } from '../modules/collect-data/components/budget/store/budget.state';
import { ICreditCardState } from '../modules/collect-data/components/credit-card/store/credit-card.state';
import { IDebtsState } from '../modules/collect-data/components/debts/store/debts.state';
import { ISettingsState } from '../modules/home/store/home.state';
import { IContactState } from '../modules/collect-data/components/end-of-collection/store/contact.state';
import {
  setObjectiveEntrepreneurshipAction,
  setObjectiveMarriageAction,
  setObjectiveOthersAction,
  setObjectivePropertyAction,
  setObjectiveRetirementAction,
  setObjectiveTripsAction,
  setObjectiveVehiclesAction,
} from '../modules/objective/store/objective.actions';
import { Store } from '@ngrx/store';
import { getObjectiveRetirementSelectors } from '../modules/objective/store/objective.selectors';
import { GoalsService } from './goals.service';
import { IGoalsData } from '../modules/interfaces/goals-dto.interface';
import { IFamilyData } from '../modules/interfaces/spouses.interface';
import { FamilyService } from './spouses.service';
import { setFamilyFormAction } from '../modules/collect-data/components/family-form/store/family-form.actions';
import { IProfession } from '../modules/interfaces/profession.interface';
import { ProfessionService } from './professions.service';
import { setJobFormAction } from '../modules/collect-data/components/job-form/store/job-form.actions';
import { IIncomeTax } from '../modules/interfaces/income-taxes.interface';
import { IncomeService } from './income-taxes.service';
import { setIncomeTaxAction } from '../modules/collect-data/components/income-tax/store/incomeTax.actions';
import { IHealthInsurance } from '../modules/interfaces/health-insurance.interface';
import { HealthInsuranceService } from './health-insurance.service';
import { setHealthInsuranceAction } from '../modules/collect-data/components/health-insurance/store/healthInsurance.actions';
import { IInsurance } from '../modules/interfaces/insurances.interface';
import { InsuranceService } from './insurances.service';
import { setInsuranceAction } from '../modules/collect-data/components/insurance/store/insurance.actions';
import { IPension } from '../modules/interfaces/pensions.interface';
import { PensionsService } from './pensions.service';
import { setPensionAction } from '../modules/collect-data/components/pension/store/pension.actions';
import {
  IIndividualsProperties,
  IProperties,
} from '../modules/interfaces/properties.interface';
import { PropertiesService } from './properties.service';
import { setPropertiesAction } from '../modules/collect-data/components/properties/store/properties.actions';
import {
  IIndividualsVehicles,
  IVehicles,
} from '../modules/interfaces/vehicles.interface';
import { VehiclesService } from './vehicles.service';
import { setVehiclesAction } from '../modules/collect-data/components/vehicles/store/vehicles.actions';
import { IInssData } from '../modules/interfaces/inss.interface';
import { InssService } from './inss.service';
import { setInssAction } from '../modules/collect-data/components/inss-retirement/store/inss.actions';
import { IInvestmentsData } from '../modules/interfaces/investments.interface';
import { InvestmentsService } from './investments.service';
import { setInvestmentsAction } from '../modules/collect-data/components/investments/store/investments.actions';
import { IBudgetData } from '../modules/interfaces/budget.interface';
import { BudgetsService } from './budget.service';
import { setBudgetAction } from '../modules/collect-data/components/budget/store/budget.actions';
import { ICreditCardData } from '../modules/interfaces/credit-card.interface';
import { CreditCardService } from './credit-cards.service';
import { setCreditCardAction } from '../modules/collect-data/components/credit-card/store/credit-card.actions';
import {
  IDebts,
  IIndividualsDebts,
} from '../modules/interfaces/debts.interface';
import { DebtsService } from './debts.service';
import { setDebtsAction } from '../modules/collect-data/components/debts/store/debts.actions';
import { IRecomendations } from '../modules/interfaces/recomendations.interface';
import { RecomendationsService } from './recomendations.service';
import { setContactAction } from '../modules/collect-data/components/end-of-collection/store/contact.actions';

@Injectable({
  providedIn: 'root',
})
export class ReportDataLoaderService {
  token: string = '';
  formsId: number = 0;
  selectedGoals: IGoalsData[] = [];

  //OBJETIVOS

  retirementGoal: IGoalsData | undefined;
  vehiclesGoal: IGoalsData | undefined;
  tripsGoal: IGoalsData | undefined;
  propertyGoal: IGoalsData | undefined;
  entrepreneurshipGoal: IGoalsData | undefined;
  marriageGoal: IGoalsData | undefined;
  othersGoal: IGoalsData | undefined;

  dataRetirementState: IObjectivesRetirementFormState;
  dataVehiclesState: IObjectivesFormState;
  dataTripsState: IObjectivesFormState;
  dataMarriageState: IObjectivesFormState;
  dataPropertyState: IObjectivesFormState;
  dataOthersState: IObjectivesFormState;
  dataEntrepreneurshipState: IObjectivesFormState;

  // COLETA DE DADOS

  professionData: IProfession;
  professionsState: IJobFormState;
  workModalities = [
    { id: 1, name: 'CLT/Regime Estatutário' },
    { id: 2, name: 'Pessoa Jurídica / Empresário' },
    { id: 3, name: 'Autônomo' },
    { id: 4, name: 'Aposentado(a)' },
  ];

  spousesData: IFamilyData;
  spousesState: IFamilyFormState;

  incomeTaxData: IIncomeTax;
  incomeState: IIncomeTaxState;
  taxTypesMap = {
    1: 'Simplificada',
    2: 'Completa',
    3: 'Sou isento(a)',
  };

  healthInsuranceData: IHealthInsurance;
  healthInsuranceState: IHealthInsuranceState;

  insuranceData: IInsurance;
  insuranceState: IInsuranceState;

  pensionData: IPension;
  pensionState: IPensionState;
  pensionTypesMap = {
    1: 'PGBL (Plano Gerador de Benefício Livre)',
    2: 'VGBL (Vida Gerador de Benefício Livre)',
    3: 'Não sei',
  };

  propertiesData: IProperties;
  propertiesState: IPropertiesState = {
    check: true,
    properties: undefined,
    interest: false,
    listProperties: [],
  };
  individualsPropertiesLocal: IIndividualsProperties[];

  vehiclesData: IVehicles;
  vehiclesState: IVehiclesState = {
    check: true,
    vehicles: undefined,
    listVehicles: [],
  };
  individualsVehiclesLocal: IIndividualsVehicles[];

  inssData: IInssData;
  inssState: IInssState;

  investmentsData: IInvestmentsData;
  investmentsState: IInvestmentsState;

  budgetData: IBudgetData;
  budgetState: IBudgetState;

  creditCardData: ICreditCardData;
  creditCardState: ICreditCardState;

  debtsData: IDebts;
  debtsState: IDebtsState = {
    check: false,
    debts: false,
    confirmDebts: false,
    listDebts: [],
  };
  typeOfCreditMap = {
    1: 'Financiamento Veicular',
    2: 'Financiamento Imobiliário',
    3: 'Cartão de Crédito',
    4: 'Crédito Consignado',
    5: 'Familiar/Amigo',
    6: 'Outros',
  };
  individualsLoansLocal: IIndividualsDebts[];

  //CONFIGURAÇÃO
  dataStoreSetting$: Observable<any>;
  dataStoreSetting: ISettingsState;

  // RECOMENDAÇÃO

  recomendationsData: IRecomendations[] = [];
  recomendationState: IContactState = {
    check: false,
    listContacts: [],
  };

  constructor(
    public http: HttpClient,
    private store: Store,
    private goalsService: GoalsService,
    private familyService: FamilyService,
    private professionService: ProfessionService,
    private incomeTaxService: IncomeService,
    private healthInsuranceService: HealthInsuranceService,
    private insuranceService: InsuranceService,
    private pensionService: PensionsService,
    private propertiesService: PropertiesService,
    private vehiclesService: VehiclesService,
    private inssService: InssService,
    private investmentsService: InvestmentsService,
    private budgetsService: BudgetsService,
    private creditCardService: CreditCardService,
    private debtsService: DebtsService,
    private recomendationsService: RecomendationsService
  ) {
    this.token = getCookie('token');
    this.formsId = Number(getCookie('formsId'));
  }

  //CARREGAMENTO DOS DADOS

  loadSelectedGoals(): void {
    this.goalsService.getGoals(this.formsId).subscribe((res: any) => {
      this.selectedGoals = res.data || [];
      this.retirementGoal = this.selectedGoals.find(
        (obj) => obj.individuals_goal_id === 1
      );
      this.tripsGoal = this.selectedGoals.find(
        (obj) => obj.individuals_goal_id === 2
      );
      this.propertyGoal = this.selectedGoals.find(
        (obj) => obj.individuals_goal_id === 3
      );
      this.vehiclesGoal = this.selectedGoals.find(
        (obj) => obj.individuals_goal_id === 4
      );
      this.entrepreneurshipGoal = this.selectedGoals.find(
        (obj) => obj.individuals_goal_id === 5
      );
      this.marriageGoal = this.selectedGoals.find(
        (obj) => obj.individuals_goal_id === 6
      );
      this.othersGoal = this.selectedGoals.find(
        (obj) => obj.individuals_goal_id === 7
      );

      this.syncGoalsWithNgRx();
    });
  }

  loadFamilyData(): void {
    this.familyService.getFamilyData(this.formsId).subscribe((response) => {
      if (response) {
        this.spousesData = {
          id: response.id,
          has_spouse: response.has_spouse,
          spouse_notes: response.spouse_notes || '',
          has_dependents: response.has_dependents,
          dependents_notes: response.dependents_notes || '',
          invest_in_future: response.dependents?.invest_in_future || 0,
          invest_notes: response.dependents?.invest_notes || '',
        };
        this.saveSpousesState();
      }
    });
  }

  loadProfessionData(): void {
    this.professionService.getProfession(this.formsId).subscribe((response) => {
      if (response) {
        this.professionData = {
          id: response.id,
          forms_id: response.forms_id,
          work_modalities_id: response.work_modalities_id,
          job_title: response.job_title || '',
        };
        this.saveProfessionsState();
      }
    });
  }

  loadIncomeTaxData(): void {
    this.incomeTaxService.getIncomeData(this.formsId).subscribe((response) => {
      if (response) {
        this.incomeTaxData = {
          id: response.id,
          income_tax_types_id: String(response.income_tax_types_id),
          refunds_last_year: response.refunds_last_year,
          income_tax_refunds: response.income_tax_refunds,
        };
        this.saveIncomeState();
      }
    });
  }

  loadHealthInsuranceData(): void {
    this.healthInsuranceService
      .getHealthInsuranceData(this.formsId)
      .subscribe((response) => {
        if (response) {
          this.healthInsuranceData = {
            id: response.id,
            has_insurance: response.has_insurance,
            insurance_name: response.insurance_name || '',
            wants_health_plan_study: response.wants_health_plan_study,
          };

          this.saveHealthInsuranceState();
        }
      });
  }

  loadInsuranceData(): void {
    this.insuranceService
      .getInsuranceData(this.formsId)
      .subscribe((response) => {
        if (response) {
          this.insuranceData = {
            id: response.id,
            has_insurance: response.has_insurance,
            insurances_name: response.insurances_name || '',
            insurance_satisfaction: response.insurance_satisfaction || '',
            wants_insurance_study: response.wants_insurance_study,
          };
          this.saveInsuranceState();
        }
      });
  }

  loadPensionData(): void {
    this.pensionService.getPensionsData(this.formsId).subscribe((response) => {
      if (response) {
        this.pensionData = {
          id: response.id,
          has_pension: response.has_pension,
          pension_types_id: response.pension_types_id,
          value_invested: response.value_invested || null,
          montly_value: response.montly_value || null,
          wants_pension_proposal: response.wants_pension_proposal,
        };
        this.savePensionState();
      }
    });
  }

  loadPropertiesData(): void {
    this.propertiesService
      .getPropertiesData(this.formsId)
      .subscribe((response) => {
        if (response) {
          (this.propertiesData = {
            id: response.id,
            has_property: response.has_property,
            wants_property_study: response.wants_property_study,
            individuals_properties: response.individuals_properties,
          }),
            (this.individualsPropertiesLocal = response.individuals_properties);
          this.saveOwnPropertiesState();
        }
      });
  }

  loadVehiclesData(): void {
    this.vehiclesService.getVehiclesData(this.formsId).subscribe((response) => {
      if (response) {
        (this.vehiclesData = {
          id: response.id,
          has_vehicles: response.has_vehicles,
          individuals_vehicles: response.individuals_vehicles,
        }),
          (this.individualsVehiclesLocal = response.individuals_vehicles);
        this.saveOwnVehiclesState();
      }
    });
  }

  loadInssData(): void {
    this.inssService.getInssData(this.formsId).subscribe((response) => {
      if (response) {
        this.inssData = {
          id: response.id,
          has_contribute: response.has_contribute,
          montly_value: response.montly_value || null,
          believes_inss_sufficient: response.believes_inss_sufficient,
          passive_retirement_income: response.passive_retirement_income || null,
        };
        this.saveInssState();
      }
    });
  }

  loadInvestmentsData(): void {
    this.investmentsService
      .getInvestmentsData(this.formsId)
      .subscribe((response) => {
        if (response) {
          this.investmentsData = {
            id: response.id,
            has_investiments: response.has_investiments,
            investiment_value: response.investiment_value || null,
            knows_advisor_fee: response.knows_advisor_fee,
            intend_to_invest: response.intend_to_invest,
          };
        }
        this.saveInvestmentsState();
      });
  }

  loadBudgetData(): void {
    this.budgetsService.getBudgetsData(this.formsId).subscribe((response) => {
      if (response) {
        this.budgetData = {
          id: response.id,
          has_budget: response.has_budget,
          montly_cost: response.montly_cost || null,
          montly_revenue: response.montly_revenue || null,
          gross_annual_revenue: response.gross_annual_revenue || null,
        };

        this.saveBudgetsState();
      }
    });
  }

  loadCreditCardData(): void {
    this.creditCardService
      .getCreditCardData(this.formsId)
      .subscribe((response) => {
        if (response) {
          this.creditCardData = {
            id: response.id,
            has_credit_card: response.has_credit_card,
            credit_card_quantity: response.credit_card_quantity || null,
            has_miles_per_cards: response.has_miles_per_cards || null,
          };
          this.saveCreditcardState();
        }
      });
  }

  loadDebtsData(): void {
    this.debtsService.getDebtsData(this.formsId).subscribe((response) => {
      if (response) {
        (this.debtsData = {
          id: response.id,
          has_debts: response.has_debts,
          wants_loans_study: response.wants_loans_study,
          individuals_loans: response.individuals_loans,
        }),
          (this.individualsLoansLocal = response.individuals_loans);
        this.saveDebtsState();
      }
    });
  }

  loadingRecomendationsData() {
    this.recomendationsService
      .getRecomendationsData(this.formsId)
      .subscribe((response) => {
        this.recomendationsData = response.data;

        this.saveRecomendationState();
      });
  }

  //OBJETIVOS

  syncGoalsWithNgRx(): void {
    const goalActionMap: Record<number, () => void> = {
      1: this.saveRetirementState.bind(this),
      2: this.saveTripsState.bind(this),
      3: this.savePropertiesState.bind(this),
      4: this.saveVehiclesState.bind(this),
      5: this.saveEntrepreneursState.bind(this),
      6: this.saveMarriageState.bind(this),
      7: this.saveOthersState.bind(this),
    };

    this.selectedGoals.forEach((goal) => {
      const action = goalActionMap[goal.individuals_goal_id];
      if (action) {
        action();
      }
    });
  }
  setRetirementState(data: IObjectivesRetirementFormState) {
    this.store.dispatch(setObjectiveRetirementAction(data));
  }
  setVehiclesState(data: IObjectivesFormState) {
    this.store.dispatch(setObjectiveVehiclesAction(data));
  }
  setTripsState(data: IObjectivesFormState) {
    this.store.dispatch(setObjectiveTripsAction(data));
  }
  setPropertyState(data: IObjectivesFormState) {
    this.store.dispatch(setObjectivePropertyAction(data));
  }
  setOtherState(data: IObjectivesFormState) {
    this.store.dispatch(setObjectiveOthersAction(data));
  }
  setMarriageState(data: IObjectivesFormState) {
    this.store.dispatch(setObjectiveMarriageAction(data));
  }
  setEntrepreneursState(data: IObjectivesFormState) {
    this.store.dispatch(setObjectiveEntrepreneurshipAction(data));
  }

  saveRetirementState() {
    this.dataRetirementState = {
      ...this.dataRetirementState,
      isSelected: true,
      check: true,
      description: this.retirementGoal.motive,
      minimumInvestment: Number(this.retirementGoal.investment_min),
      maximumInvestment: Number(this.retirementGoal.investment_max),
      observation: this.retirementGoal.observation,
      currentAge: this.retirementGoal.current_age,
      yearIntention: this.retirementGoal.retirement_age,
      forecastYear: this.retirementGoal.retirement_year,
    };
    this.setRetirementState(this.dataRetirementState);
  }

  saveVehiclesState(): void {
    this.dataVehiclesState = {
      ...this.dataVehiclesState,
      isSelected: true,
      check: true,
      description: this.vehiclesGoal.motive,
      date: new Date(this.vehiclesGoal.target_date),
      minimumInvestment: Number(this.vehiclesGoal.investment_min),
      maximumInvestment: Number(this.vehiclesGoal.investment_max),
      observation: this.vehiclesGoal.observation,
    };
    this.setVehiclesState(this.dataVehiclesState);
  }

  saveTripsState(): void {
    this.dataTripsState = {
      ...this.dataTripsState,
      isSelected: true,
      check: true,
      description: this.tripsGoal.motive,
      date: new Date(this.tripsGoal.target_date),
      minimumInvestment: Number(this.tripsGoal.investment_min),
      maximumInvestment: Number(this.tripsGoal.investment_max),
      observation: this.tripsGoal.observation,
    };
    this.setTripsState(this.dataTripsState);
  }

  savePropertiesState(): void {
    this.dataPropertyState = {
      ...this.dataPropertyState,
      isSelected: true,
      check: true,
      description: this.propertyGoal.motive,
      date: new Date(this.propertyGoal.target_date),
      minimumInvestment: Number(this.propertyGoal.investment_min),
      maximumInvestment: Number(this.propertyGoal.investment_max),
      observation: this.propertyGoal.observation,
    };
    this.setPropertyState(this.dataPropertyState);
  }

  saveOthersState(): void {
    (this.dataOthersState = {
      ...this.dataOthersState,
      isSelected: true,
      objectiveName: this.othersGoal.name,
      check: true,
      description: this.othersGoal.motive,
      date: new Date(this.othersGoal.target_date),
      minimumInvestment: Number(this.othersGoal.investment_min),
      maximumInvestment: Number(this.othersGoal.investment_max),
      observation: this.othersGoal.observation,
    }),
      this.setOtherState(this.dataOthersState);
  }

  saveMarriageState(): void {
    this.dataMarriageState = {
      ...this.dataMarriageState,
      isSelected: true,
      check: true,
      description: this.marriageGoal.motive,
      date: new Date(this.marriageGoal.target_date),
      minimumInvestment: Number(this.marriageGoal.investment_min),
      maximumInvestment: Number(this.marriageGoal.investment_max),
      observation: this.marriageGoal.observation,
    };
    this.setMarriageState(this.dataMarriageState);
  }

  saveEntrepreneursState(): void {
    this.dataEntrepreneurshipState = {
      ...this.dataEntrepreneurshipState,
      isSelected: true,
      check: true,
      description: this.entrepreneurshipGoal.motive,
      date: new Date(this.entrepreneurshipGoal.target_date),
      minimumInvestment: Number(this.entrepreneurshipGoal.investment_min),
      maximumInvestment: Number(this.entrepreneurshipGoal.investment_max),
      observation: this.entrepreneurshipGoal.observation,
    };
    this.setEntrepreneursState(this.dataEntrepreneurshipState);
  }

  //COLETA DE DADOS

  saveSpousesState(): void {
    this.spousesState = {
      ...this.spousesState,
      check: true,
      married: {
        isSelected: this.spousesData.has_spouse === 1,
        notes: this.spousesData.spouse_notes || '',
      },
      children: {
        isSelected: this.spousesData.has_dependents === 1,
        notes: this.spousesData.dependents_notes || '',
      },
      childrenInvestment: {
        isSelected: this.spousesData.invest_in_future === 1,
        notes: this.spousesData.invest_notes || '',
      },
    };

    this.setSpousesState(this.spousesState);
  }

  setSpousesState(data) {
    this.store.dispatch(setFamilyFormAction(data));
  }

  saveProfessionsState(): void {
    const selectedWorkModality = this.workModalities.find(
      (modality) => modality.id === this.professionData.work_modalities_id
    );

    this.professionsState = {
      ...this.professionsState,
      check: true,
      job: this.professionData.job_title || '',
      typeJob: selectedWorkModality ? selectedWorkModality.name : '',
    };

    this.setProfessionsState(this.professionsState);
  }

  setProfessionsState(data: IJobFormState) {
    this.store.dispatch(setJobFormAction(data));
  }

  saveIncomeState(): void {
    const taxName =
      this.taxTypesMap[this.incomeTaxData.income_tax_types_id] || '';
    this.incomeState = {
      ...this.incomeState,
      check: true,
      typeTax: taxName,
      refunded: this.incomeTaxData.refunds_last_year,
      amount: this.incomeTaxData.income_tax_refunds || 0,
    };

    this.setIncomeState(this.incomeState);
  }

  setIncomeState(data: IIncomeTaxState) {
    this.store.dispatch(setIncomeTaxAction(data));
  }

  saveHealthInsuranceState(): void {
    this.healthInsuranceState = {
      ...this.healthInsuranceState,
      check: true,
      insurance: this.healthInsuranceData.has_insurance === 1,
      insuranceName: this.healthInsuranceData.insurance_name || '',
      interest: this.healthInsuranceData.wants_health_plan_study === 1,
    };

    this.setHealthInsuranceState(this.healthInsuranceState);
  }

  setHealthInsuranceState(data: IHealthInsuranceState) {
    this.store.dispatch(setHealthInsuranceAction(data));
  }

  saveInsuranceState(): void {
    this.insuranceState = {
      ...this.insuranceState,
      check: true,
      insurance: this.insuranceData.has_insurance === 1,
      insuranceName: this.insuranceData.insurances_name || '',
      safeWithInsurance: this.insuranceData.insurance_satisfaction || '',
      interest: this.insuranceData.wants_insurance_study === 1,
    };

    this.setInsuranceState(this.insuranceState);
  }

  setInsuranceState(data: IInsuranceState) {
    this.store.dispatch(setInsuranceAction(data));
  }

  savePensionState(): void {
    const pensionName =
      this.pensionTypesMap[this.pensionData.pension_types_id] || '';

    this.pensionState = {
      ...this.pensionState,
      check: true,
      pension: this.pensionData.has_pension === 1,
      typePension: pensionName,
      amount: this.pensionData.value_invested || 0,
      notes: this.pensionData.montly_value || 0,
      interest: this.pensionData.wants_pension_proposal === 1,
    };

    this.setPensionState(this.pensionState);
  }

  setPensionState(data: IPensionState) {
    this.store.dispatch(setPensionAction(data));
  }

  saveOwnPropertiesState(): void {
    this.propertiesState = {
      ...this.propertiesState,
      check: this.individualsPropertiesLocal.length > 0,
      properties: this.propertiesData.has_property === 1,
      interest: this.propertiesData.wants_property_study === 1,
      listProperties: this.individualsPropertiesLocal.map((property) => ({
        check: true,
        estimatedValue: Number(property.property_value),
        propertyFinanced: property.has_financed === 1,
        notes: property.notes || '',
      })),
    };

    this.setOwnPropertiesState(this.propertiesState);
  }

  setOwnPropertiesState(data: IPropertiesState) {
    this.store.dispatch(setPropertiesAction(data));
  }

  saveOwnVehiclesState(): void {
    const formattedListVehicles = this.individualsVehiclesLocal.map(
      (vehicle) => ({
        check: true,
        model: vehicle.description || '',
        yearOfPurchase: vehicle.purchased_year || 0,
        estimatedValue: Number(vehicle.vehicles_value) || 0,
      })
    );

    this.vehiclesState = {
      ...this.vehiclesState,
      check: this.individualsVehiclesLocal.length > 0,
      vehicles: this.vehiclesData.has_vehicles === 1,
      listVehicles: formattedListVehicles,
    };

    this.setOwnVehiclesState(this.vehiclesState);
  }

  setOwnVehiclesState(data: IVehiclesState): void {
    this.store.dispatch(setVehiclesAction(data));
  }

  saveInssState(): void {
    this.inssState = {
      ...this.inssState,
      check: true,
      contribute: this.inssData.has_contribute === 1,
      retirement: this.inssData.believes_inss_sufficient === 1,
      amountRetirement: this.inssData.passive_retirement_income || 0,
      amountMonth: this.inssData.montly_value || 0,
    };

    this.setInssState(this.inssState);
  }

  setInssState(data: IInssState) {
    this.store.dispatch(setInssAction(data));
  }

  saveInvestmentsState(): void {
    this.investmentsState = {
      ...this.investmentsState,
      check: true,
      investments: this.investmentsData.has_investiments === 1,
      accessorPayment: this.investmentsData.knows_advisor_fee === 1,
      amount: Number(this.investmentsData.investiment_value) || 0,
      feeModel: this.investmentsData.knows_advisor_fee === 1,
      interest: this.investmentsData.intend_to_invest === 1,
    };

    this.setInvestimentsState(this.investmentsState);
  }

  setInvestimentsState(data: IInvestmentsState) {
    this.store.dispatch(setInvestmentsAction(data));
  }

  saveBudgetsState(): void {
    this.budgetState = {
      check: true,
      idealBudget: Boolean(this.budgetData.has_budget),
      monthlyCost: Number(this.budgetData.montly_cost),
      monthlyIncome: Number(this.budgetData.montly_revenue),
      annualRecipe: Number(this.budgetData.gross_annual_revenue),
    };
    this.setBudgetState(this.budgetState);
  }

  setBudgetState(data: IBudgetState) {
    this.store.dispatch(setBudgetAction(data));
  }

  saveCreditcardState(): void {
    this.creditCardState = {
      ...this.creditCardState,
      check: true,
      creditCard: this.creditCardData.has_credit_card === 1,
      cards: Number(this.creditCardData.credit_card_quantity) || 0,
      miles: this.creditCardData.has_miles_per_cards === 1,
    };

    this.setCreditcardState(this.creditCardState);
  }

  setCreditcardState(data: ICreditCardState) {
    this.store.dispatch(setCreditCardAction(data));
  }

  saveDebtsState(): void {
    const formattedListDebts = this.individualsLoansLocal.map((debt) => ({
      check: true,
      typeDebt: this.typeOfCreditMap[debt.type_of_credit_id] || 'Outros',
      contractValue: debt.contract_value || 0,
      installmentValue: debt.installment_value || 0,
      interestRate: String(debt.interest_rate) || '',
      interestRateChoose: debt.interest_rate_period || '',
    }));

    this.debtsState = {
      ...this.debtsState,
      check: this.individualsLoansLocal.length > 0,
      debts: this.debtsData.has_debts === 1,
      confirmDebts: this.debtsData.wants_loans_study === 1,
      listDebts: formattedListDebts,
    };

    this.setDebtsState(this.debtsState);
  }

  setDebtsState(data: IDebtsState): void {
    this.store.dispatch(setDebtsAction(data));
  }

  saveRecomendationState() {
    this.recomendationState = {
      ...this.recomendationState,
      check: this.recomendationsData.length > 0,
      listContacts: this.recomendationsData.map((contact) => ({
        name: contact.name,
        email: contact.email,
        phone: contact.phone,
        notes: contact.notes,
      })),
    };

    this.setRecomendationState(this.recomendationState);
  }

  setRecomendationState(data: IContactState): void {
    this.store.dispatch(setContactAction(data));
  }
}
